/** Parsing de células Excel para importação (orçamento, realizado complementar, etc.). */

export function parseExcelDate(value: unknown): string | null {
  if (value === null || value === undefined || value === '') return null

  if (value instanceof Date) {
    if (isNaN(value.getTime())) return null
    const year = value.getFullYear()
    const month = String(value.getMonth() + 1).padStart(2, '0')
    const day = String(value.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  if (typeof value === 'number') {
    try {
      let date: Date
      if (value > 0 && value < 1000000) {
        const excelEpoch = new Date(1899, 11, 30)
        date = new Date(excelEpoch.getTime() + value * 24 * 60 * 60 * 1000)
      } else if (value > 1000000000000) {
        date = new Date(value)
      } else if (value > 1000000000) {
        date = new Date(value * 1000)
      } else {
        return null
      }

      if (!isNaN(date.getTime())) {
        const year = date.getFullYear()
        if (year < 1900 || year > 2100) return null
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }
    } catch {
      return null
    }
  }

  const dateStr = String(value).trim()
  if (!dateStr || dateStr === 'null' || dateStr === 'undefined') return null

  const numFromStr = parseFloat(dateStr)
  if (!isNaN(numFromStr) && numFromStr > 0 && numFromStr < 1000000) {
    try {
      const excelEpoch = new Date(1899, 11, 30)
      const date = new Date(excelEpoch.getTime() + numFromStr * 24 * 60 * 60 * 1000)
      if (!isNaN(date.getTime())) {
        const year = date.getFullYear()
        if (year >= 1900 && year <= 2100) {
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          return `${year}-${month}-${day}`
        }
      }
    } catch {
      /* continuar */
    }
  }

  if (dateStr.includes('/')) {
    const parts = dateStr.split('/').map((p) => p.trim()).filter(Boolean)
    if (parts.length === 3) {
      let day = parseInt(parts[0], 10)
      let month = parseInt(parts[1], 10)
      let year = parseInt(parts[2], 10)
      if (isNaN(day) || isNaN(month) || isNaN(year)) return null
      if (year < 100) year = year < 50 ? 2000 + year : 1900 + year
      if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1900 || year > 2100) return null
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    }
  }

  if (dateStr.includes('-')) {
    const parts = dateStr.split('-').filter((p) => p.trim())
    if (parts.length === 3) {
      const first = parseInt(parts[0], 10)
      const second = parseInt(parts[1], 10)
      const third = parseInt(parts[2], 10)
      if (isNaN(first) || isNaN(second) || isNaN(third)) return null
      let year: number
      let month: number
      let day: number
      if (first > 31) {
        year = first
        month = second
        day = third
      } else {
        day = first
        month = second
        year = third
        if (year < 100) year = year < 50 ? 2000 + year : 1900 + year
      }
      if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1900 || year > 2100) return null
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    }
  }

  try {
    const date = new Date(dateStr)
    if (!isNaN(date.getTime())) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  } catch {
    /* ignore */
  }

  return null
}

export function parseExcelNumber(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null
  if (typeof value === 'number') return isNaN(value) ? null : value

  let str = String(value).trim()
  str = str.replace(/[^\d.,-]/g, '')
  const hasComma = str.includes(',')
  const hasDot = str.includes('.')

  if (hasComma && hasDot) {
    const lastComma = str.lastIndexOf(',')
    const lastDot = str.lastIndexOf('.')
    if (lastComma > lastDot) str = str.replace(/\./g, '').replace(',', '.')
    else str = str.replace(/,/g, '')
  } else if (hasComma && !hasDot) {
    const parts = str.split(',')
    if (parts[1] && parts[1].length <= 2) str = str.replace(',', '.')
    else str = str.replace(',', '')
  } else if (hasDot && !hasComma) {
    const parts = str.split('.')
    if (!(parts[1] && parts[1].length <= 2)) str = str.replace(/\./g, '')
  }

  const num = parseFloat(str)
  return isNaN(num) ? null : num
}
